const ApiUrl = 'https://bilur.goldpos.com.co/apiGold/';

const ApiRaiz = 'http://bilur.goldpos.com.co/';

const ColorBilu = '#412567'



export { ApiUrl, ApiRaiz, ColorBilu }
